/* Warning: this file is generated using svg-icon-builder */
import React from 'react';
import makeClass from 'clsx';
import { IconProps, IconSizes } from '../props';
import { SLOT_TOKEN } from '../slot';

import styles from '../Icon.css';

/**
 * ChevronDownIcon
 *
 * @param iconProps - SVG props
 */
const ChevronDownIcon = (iconProps: IconProps) => {
  const { className, fill, size, inline, ...html } = iconProps;
  const iconSize = size ? IconSizes[size] : undefined;

  return (
    <svg
      aria-hidden
      focusable="false"
      viewBox="0 0 24 24"
      className={makeClass(className, { [styles.inline]: inline })}
      width={iconSize}
      height={iconSize}
      fill={fill || 'currentColor'}
      {...html}
    >
      <path d="M12.014 16.018a1 1 0 01-.708-.294L5.314 9.715A1.001 1.001 0 016.73 8.3l5.286 5.3 5.3-5.285a1 1 0 011.413 1.416l-6.009 5.995a1 1 0 01-.706.292z" />
    </svg>
  );
};

ChevronDownIcon._SLOT_ = SLOT_TOKEN;

export default ChevronDownIcon;
